/**
 * @generated SignedSource<<b13cf08b05785780a8b3e00d890ca7b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventEditType = "ALL" | "FOLLOWING" | "THIS";
export type ResponseStatusChoices = "accepted" | "declined" | "needsAction" | "none" | "notResponded" | "organizer" | "tentative" | "tentativelyAccepted";
export type MeetingsPanelAttendanceMutation$variables = {
  calendarId: string;
  editType?: EventEditType | null;
  guid: string;
  userResponseStatus: ResponseStatusChoices;
};
export type MeetingsPanelAttendanceMutation$data = {
  readonly eventAttendance: {
    readonly event: {
      readonly guid: string;
      readonly id: string;
    } | null;
  } | null;
};
export type MeetingsPanelAttendanceMutation = {
  response: MeetingsPanelAttendanceMutation$data;
  variables: MeetingsPanelAttendanceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "calendarId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "editType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guid"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userResponseStatus"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "calendarId",
        "variableName": "calendarId"
      },
      {
        "kind": "Variable",
        "name": "editType",
        "variableName": "editType"
      },
      {
        "kind": "Variable",
        "name": "guid",
        "variableName": "guid"
      },
      {
        "kind": "Variable",
        "name": "userResponseStatus",
        "variableName": "userResponseStatus"
      }
    ],
    "concreteType": "EventAttendanceMutation",
    "kind": "LinkedField",
    "name": "eventAttendance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guid",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingsPanelAttendanceMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "MeetingsPanelAttendanceMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "31eb18520347d250878e33019c688cec",
    "id": null,
    "metadata": {},
    "name": "MeetingsPanelAttendanceMutation",
    "operationKind": "mutation",
    "text": "mutation MeetingsPanelAttendanceMutation(\n  $calendarId: ID!\n  $guid: String!\n  $userResponseStatus: ResponseStatusChoices!\n  $editType: EventEditType\n) {\n  eventAttendance(calendarId: $calendarId, guid: $guid, userResponseStatus: $userResponseStatus, editType: $editType) {\n    event {\n      id\n      guid\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f95c09e0fddae5db978283b7c5dc6423";

export default node;
